import educationDetailsLocale from './en.json'

const en = {
  educationDetails: educationDetailsLocale,
}

export default en
